import { PerspectiveTrxLookupViewer } from '@/common/entityFramework/entityPerspective/PerspectiveTrxLookupViewer';
import { Route } from 'react-router-dom';
import { ApiDocs } from './actuator/ApiDocs';
import { Info } from './actuator/Info';
import { LogFile } from './actuator/LogFile';
import { Loggers } from './actuator/Loggers';
import { Metrics } from './actuator/Metrics';
import { PerspectiveTrxPivotViewer } from './entityFramework/entityPerspective/PerspectiveTrxPivotViewer';
import { PerspectiveTrxViewer } from './entityFramework/entityPerspective/PerspectiveTrxViewer';
import { EntityView } from './entityFramework/entityView/EntityView';
import { Home } from './home/Home';
import { Interact } from './interact/Interact';
import { InteractLogs } from './interact/InteractLogs';

const commonRoutes = [
  <Route path="/" element={<Home />} />,
  <Route path="/:module/org" element={<EntityView />} />,
  <Route path="/:module/config" element={<EntityView />} />,
  <Route path="/:module/sub" element={<EntityView />} />,
  <Route path="/:module/val" element={<EntityView />} />,
  <Route path="/:module/interact" element={<Interact />} />,
  <Route path="/:module/interact-logs" element={<InteractLogs />} />,
  <Route path="/:module/entity-prop" element={<EntityView />} />,
  <Route path="/:module/entity-file" element={<EntityView />} />,
  <Route path="/:module/entity-comment" element={<EntityView />} />,
  <Route path="/:module/perspective-trx-viewer" element={<PerspectiveTrxViewer />} />,
  <Route path="/:module/perspective-trx-lookup-viewer" element={<PerspectiveTrxLookupViewer />} />,
  <Route path="/:module/perspective-pivot" element={<PerspectiveTrxPivotViewer />} />,
  <Route path="/:module/closure" element={<EntityView />} />,
  <Route path="/:module/perspective-adj" element={<EntityView />} />,
  <Route path="/:module/plugin-info" element={<EntityView />} />,
  <Route path="/:module/metrics" element={<Metrics />} />,
  <Route path="/:module/info" element={<Info />} />,
  <Route path="/:module/log-file" element={<LogFile />} />,
  <Route path="/:module/loggers" element={<Loggers />} />,
  <Route path="/:module/openapi" element={<ApiDocs />} />,
  <Route path="/:module/filter" element={<EntityView />} />,
  <Route path="/:module/inc-list" element={<EntityView />} />,
  <Route path="/:module/inc-data-src" element={<EntityView />} />,
  <Route path="/:module/inc-rule" element={<EntityView />} />,
  <Route path="/:module/inc-cond" element={<EntityView />} />,
];

export default commonRoutes;
